export const GET_TIME_ASSETS = 'GET_TIME_ASSETS';
export const GET_TIME_ASSET_BY_ID = 'GET_TIME_ASSET_BY_ID';
export const UPDATE_TIME_ASSET = 'UPDATE_TIME_ASSET';
export const DELETE_TIME_ASSET = 'DELETE_TIME_ASSET';
export const CREATE_TIME_ASSET = 'CREATE_TIME_ASSET';
